import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SharedModule } from '../../shared.module';
import { CookieManagerComponent } from './cookie-manager.component';

@NgModule({
  declarations: [CookieManagerComponent],
  imports: [
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  exports: [CookieManagerComponent],
})
export class CookieManagerModule {}
